module.exports = __webpack_public_path__ + "img/gift2-03-c1.d8a69132.png";